import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

interface SubscriptionGuardProps {
  children: React.ReactNode;
}

const SubscriptionGuard: React.FC<SubscriptionGuardProps> = ({ children }) => {
  const currentUser = useSelector((state: any) => state.users?.currentUser);
  
  if (!currentUser) {
    return <Navigate to="/login-page" replace />;
  }

  const selectedRole = currentUser.selectedAffiliation?.role;
  const subscriptionStatus = currentUser.subscriptionStatus;
  
  // Check subscription status (skip for owners)
  if (selectedRole !== 'owner') {
    // Check if the user is missing a school affiliation
    const hasNoSchool = !currentUser.selectedAffiliation?.schoolID;
    const isEnrolledRole = ['school_staff', 'student', 'guardian'].includes(selectedRole);

    // expiry status
    // merry christmass
    const isSubscriptionActive = subscriptionStatus === 'active' || subscriptionStatus === 'trial';
    const isBillingPage = window.location.pathname === '/dashboard/subscription';
    
    if (!isSubscriptionActive && !isBillingPage && !(hasNoSchool && isEnrolledRole)) {
      return <Navigate to="/subscription-expired" replace />;
    }
  }

  return <>{children}</>;
};

export default SubscriptionGuard;
